module.exports = __webpack_public_path__ + "static/media/sass.a6909abc.jpg";